import React from 'react';
import { graphql } from 'gatsby';
import { PopUp } from '@agria/theme/src/components/popup/PopUp';
import { UmbracoForm } from '@agria/theme/src/components/umbracoForm/UmbracoForm';
import { ModalProvider } from '../../../../context/modalContext';

export const ButtonBarForm = ({ data, ...rest }) => (
  <ModalProvider>
    <PopUp
      isButtonBarFormPopup
      actionLabel={data.label}
      actionVariant="primary"
      modalButtonLabel={data.label}
    >
      <div style={{ minHeight: '470px' }}>
        {data.formContent?.umbracoForm?.formData && (
          <UmbracoForm formData={data.formContent?.umbracoForm?.formData} />
        )}
      </div>
    </PopUp>
  </ModalProvider>
);

export const ButtonBarFormQuery = graphql`
  fragment ButtonBarForm on UMBRACO_ButtonBarFormComponentType {
    label
    formContent {
      ...Form
    }
  }
`;
